import { useCallback } from "react";
import { reportingService } from "services";
import { MonthlyCaTable } from "./MonthlyCaTable";
export const ChiffreAffaireParSecteur = () => {
  const load = useCallback((params: Record<string, any>) => reportingService.findCaMensuelBySecteurs(params), []);
  return <MonthlyCaTable label="Secteur d’activité" load={load} />;
};
